import { useEffect, useRef, useState } from "react";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import MainHeading from "../../../components/comman/MainHeading";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function TransferAssets() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [state, setState] = useState({
    machineryList: [],
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: "",
    tableLoader: false,
    sortByDate: [
      moment(moment().subtract(30, "days").toDate()).format("YYYY-MM-DD"),
      moment(moment().toDate()).format("YYYY-MM-DD"),
    ],
    siteId: "",
    user: "",
  });
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  useEffect(() => {
    GetTransferAsset();
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.sortByDate,
    pageStates?.pageSize,
    filterDetails?.orderBy,
    filterDetails?.year,
  ]);

  const GetTransferAsset = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_transfer_asset + "?" + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy, year: filterDetails?.year });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.transferAsset?.map((item) => ({
          ...item,
          Date: moment(item?.date).format("DD/MM/YYYY"),
          fromSite: item?.fromSite?.name,
          toSite: item?.toSite?.name,
          createdBy: item?.user?.name,
        }));
        setState((pre) => ({
          ...pre,
          machineryList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const HandleView = (data) => {
    navigate(RoutesLink.transfer_asset_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_transfer_asset, { state: { data: data } });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggle();
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_transfer_asset + `?transferAssetId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetTransferAsset(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "taNumber", label: "TA No." },
    { value: "Date", label: "Date" },
    { value: "fromSite", label: "From Site" },
    { value: "toSite", label: "To Site" },
    { value: "createdBy", label: "Created By" },
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
        {
          label: "Update",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "update",
          clickHandler: HandleUpdate,
        },
      ]
      : []),
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
        {
          label: "Delete",
          className: "btn btn-link",
          icon: <DeleteIcon />,
          title: "delete",
          clickHandler: ActionHandler,
        },
      ]
      : []),
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };
  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const handleExport = () => {
    let filterData = {
      exportDataType: "transferAsset",
      searchQuery: pageStates?.searchQuery,
      ...pageStates
    };
    delete pageStates?.currentPage;
    delete pageStates?.pageSize;
    delete pageStates?.count;
    delete pageStates?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const handleYearChange = (year) => {
    dispatch(
      updateFiltersStates({
        year: year,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Transfer Assest"}
          buttonText={"Transfer Assets"}
          buttonIcon={<PlusIcon />}
          buttonLink={
            !(
              userDetails?.type === 2 ||
              userDetails?.designation?.name === "Coordinator"
            ) && RoutesLink?.create_transfer_asset
          }
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        <div className="card">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              exportBtn={true}
              handleExport={state?.machineryList?.length > 0 ? handleExport : null}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={state?.machineryList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </div>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
